import isEpicPlan from 'utils/pivot/plan/isEpicPlan'

function isRXPlan(plan) {
  return isEpicPlan(plan) && plan.coreBenefits.rxSchedule === '04'
}

export default isRXPlan
